export const SettingsPage = () => (
  <div>
    <h1>SettingsPage works</h1>
  </div>
);
